export function formatCurrency(amount, currency = 'LKR') {
  return new Intl.NumberFormat('en-LK', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(amount)
}

export function formatCurrencyCompact(amount) {
  if (amount >= 1000000) {
    return `Rs.${(amount / 1000000).toFixed(1)}M`
  } else if (amount >= 1000) {
    return `Rs.${(amount / 1000).toFixed(1)}K`
  } else {
    return `Rs.${amount.toFixed(2)}`
  }
}

/**
 * Calculate percentage with proper rounding to avoid floating point issues
 * @param {number} amount - The base amount
 * @param {number} percentage - The percentage (e.g., 10 for 10%)
 * @returns {number} - The calculated amount rounded to 2 decimal places
 */
export function calculatePercentage(amount, percentage) {
  return Math.round((amount * percentage / 100) * 100) / 100
}

/**
 * Calculate service fee (typically 10%)
 * @param {number} amount - The base amount
 * @param {number} rate - The service fee rate (default 10%)
 * @returns {number} - The service fee amount rounded to 2 decimal places
 */
export function calculateServiceFee(amount, rate = 10) {
  return calculatePercentage(amount, rate)
}

/**
 * Round amount to nearest cent to avoid floating point issues
 * @param {number} amount - The amount to round
 * @returns {number} - The rounded amount
 */
export function roundToCent(amount) {
  return Math.round(amount * 100) / 100
}